import { cn } from "@/utils/cn";
import { memo } from "react";

interface CheckCircleIconProps {
  className?: string;
}

export const CheckCircleIcon = memo(function CheckCircleIcon({
  className,
}: CheckCircleIconProps) {
  return (
    <img
      src="/assets/icons/check-circle.svg"
      alt="check-circle"
      className={cn("w-6 h-6", className)}
    />
  );
});
